import React from "react";
import moment from "moment";

import classes from "./styles.module.scss";

const TransactionDate = ({ date }) => {
    const formattedDate = moment.unix(date).format("MMM D, YYYY");
    const time = moment.unix(date).format("h:mm A");

    return (
        <div className={classes.dateContainer}>
            <span className={classes.dateText}>{formattedDate}</span>
            <span className={classes.timeText}>{time}</span>
        </div>
    );
};

export default TransactionDate;
